import * as React from 'react';
import Button from '../../../../components/@common/Button';

import { PAGE_LIST } from '../../../../constants';
import useStores from '../../../../hooks/useStores';
import Card from '../../../../components/Card';

function CardEditConfirm({ focusCardIndex, onClickCloseButton }) {
  const { AppHandler, CardWallet } = useStores();

  const focusCardData = CardWallet.getCardData(focusCardIndex);

  const onClickEditButton = () => {
    CardWallet.setEditCardIndex(focusCardIndex);
    AppHandler.setAppLocation(PAGE_LIST.CARD_EDITOR);
  };

  const onClickDeleteButton = () => {
    if (!confirm('정말 해당 카드를 제거하시겠습니까?')) return;

    try {
      CardWallet.removeCardData(focusCardIndex);
      AppHandler.notifyCardUpdate(CardWallet.list);
    } catch (error) {
      alert(error.message);
      return;
    }

    onClickCloseButton();
  };

  return (
    <>
      <h2>카드 편집</h2>
      {focusCardData && <Card {...focusCardData} />}
      <div className="button-container flex">
        <Button type="primary" width="50%" onClick={onClickEditButton}>
          편집
        </Button>
        <Button type="warning" width="50%" onClick={onClickDeleteButton}>
          삭제
        </Button>
      </div>
      <Button width="100%" onClick={onClickCloseButton}>
        닫기
      </Button>
    </>
  );
}

export default CardEditConfirm;
